import dayjs from "dayjs";
import { StatsFiguresDTO } from "../../HubSpot/useGetSchedulerCloserStats.ts";

export function formatRate(rate: number | null): string {
  return rate === null ? "—" : `${Math.round(rate * 1000) / 10}%`;
}

export function capSaturation(figures: StatsFiguresDTO): number | null {
  return figures.capacityTotal === 0
    ? null
    : figures.callsOnCapacityDays / figures.capacityTotal;
}

export function dataStartNote(
  fromDay: string,
  dataFromDay: string,
): string | null {
  return fromDay < dataFromDay
    ? `Dati HubSpot dal ${dayjs(dataFromDay).format("DD/MM/YYYY")}: prima ci sono solo import da altri sistemi, che non si contano.`
    : null;
}

export function weekLabel(weekStart: string): string {
  return dayjs(weekStart).format("DD/MM");
}
